import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import Dashboard from "@/pages/Dashboard";
import Documents from "@/pages/Documents";
import DocumentDetail from "@/pages/DocumentDetail";
import ActivityLogs from "@/pages/ActivityLogs";
import DeltaTracking from "@/pages/DeltaTracking";
import MockExams from "@/pages/MockExams";
import UserManagement from "@/pages/UserManagement";
import Layout from "@/components/Layout";
import "@/App.css";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Redirection directe vers le dashboard - pas de login */}
          <Route path="/login" element={<Navigate to="/" replace />} />
          <Route path="/" element={<Layout />}>
            <Route index element={<Dashboard />} />
            <Route path="documents" element={<Documents />} />
            <Route path="documents/:id" element={<DocumentDetail />} />
            <Route path="logs" element={<ActivityLogs />} />
            <Route path="delta" element={<DeltaTracking />} />
            <Route path="exams" element={<MockExams />} />
            <Route path="users" element={<UserManagement />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster 
        position="bottom-right"
        toastOptions={{
          style: {
            background: '#151A26',
            border: '1px solid #262D3D',
            color: '#fff',
          },
        }}
      />
    </AuthProvider>
  );
}

export default App;
